import {
    IAnalyticsService,
    TRACKER_PARTNER,
} from '../definitions/IAnalyticsService'
import { DefaultAnalyticsDelegate } from './DefaultAnalyticsDelegate'
import { parseSearchParams } from '../../utils/URL'

export class FlippWebDistAnalyticsDelegate
    extends DefaultAnalyticsDelegate
    implements IAnalyticsService
{
    private _profileId: string
    private _origin_flyer: string

    constructor() {
        super()
        /* Initialize the partner GA tracker based on the profile passed in provided */
        const search = parseSearchParams(new URL(window.location.href))
        this._profileId = search['ga_profile']
        if (this._profileId) {
            /* Initialize the partner GA tracker */
            ga('create', this._profileId, 'auto', TRACKER_PARTNER)
            ga('set', 'forceSSL', true)
            // ga("set", "dimension5", this.config.BUILD);
        }

        if (search['flyer_id'] != null) {
            this._origin_flyer = search['flyer_id']
        }

        if (search['channel_id'] !== null) {
            this._analyticsParameters['channel_id'] = search['channel_id']
        }

        if (search['utm_source'] !== null) {
            this._analyticsParameters['utm_source'] = search['utm_source']
        }

        if (search['utm_term'] !== null) {
            this._analyticsParameters['utm_term'] = search['utm_term']
        }

        if (search['utm_medium'] !== null) {
            this._analyticsParameters['utm_medium'] = search['utm_medium']
        }

        if (search['utm_content'] !== null) {
            this._analyticsParameters['utm_content'] = search['utm_content']
        }

        if (search['utm_campaign'] !== null) {
            this._analyticsParameters['utm_campaign'] = search['utm_campaign']
        }
    }

    get profileId() {
        return this._profileId
    }

    originFlyerId() {
        return this._origin_flyer
    }
}
